function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 860,
    height: 900,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#feffff",
      stroke: "none"
    },
    d: "M410 604C400.083 599.31 391.443 592.849 381 589.054C357.689 580.582 332.412 582.264 309 589.435C276.644 599.347 257.982 633.446 278.363 664C288.995 679.94 308.904 685.989 327 688.155C364.82 692.683 424.395 688.056 439.91 645C444.798 631.435 443 616.178 443 602L443 527L443 270C455.462 278.209 467.939 286.552 482 291.935C505.918 301.092 538.07 307.419 554.467 329C562.949 340.164 557.672 358.146 550.934 369C546.014 376.927 534.335 383.822 546.001 391.623C553.056 396.342 564.362 380.781 568.192 376C583.879 356.422 592.48 330.036 588.83 305C586.146 286.585 571.285 272.686 556 263.731C527.339 246.938 493.675 241.641 465 224.547C457.43 220.034 447.944 214.338 444.14 206C442.343 202.062 444.612 195.936 441.972 192.603C439.167 189.062 415.102 189.408 411.603 192.179C407.258 195.621 410 212.769 410 218L410 294L410 604z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.0f69c3465d6d13cffabc67b9c6fddea8.svg";
export { ForwardRef as ReactComponent };